import React from 'react'

import { City, MultipleAddressLine, Region, Text } from '@grandvisionhq/forms'
import { useIntl } from '@grandvisionhq/state'

const OpticianForm = () => {
  const { getLabel } = useIntl()

  return (
    <>
      <Text
        id="opticianName"
        data-t="optician-name"
        label={getLabel('products.contactLens.info.optician.name')}
        errorMessage={getLabel('products.contactLens.info.optician.name.errorMessage')}
        maxLength={40}
      />
      <MultipleAddressLine
        label={getLabel('checkout.address.addressLine')}
        errorMessage={getLabel('checkout.address.addressLine.errorMessage')}
        addLineLabel={getLabel('checkout.address.addressLine.addAddressLine')}
        maxLength={50}
      />
      <City
        label={getLabel('checkout.address.city')}
        errorMessage={getLabel('checkout.address.city.errorMessage')}
        maxLength={50}
      />
      <Region
        required={false}
        label={getLabel('checkout.address.district')}
        errorMessage={getLabel('checkout.address.district.errorMessage')}
        optionalText={getLabel('checkout.form.field.optional')}
        maxLength={50}
      />
    </>
  )
}

export default OpticianForm
